export default {
  methods: {
    useRpc(method, data, onSuccess, onErorr) {
      const rpcData = () => {
        return this.$cookies.isKey("user-token")
          ? Object.assign({ auth_token: this.$cookies.get("user-token") }, data)
          : data;
      };
      console.log("rpcData send " + method, rpcData());

      this.$JsonRpcVueClient.request(method, rpcData()).then(
        response => {
          console.log("rpc response --- " + method, response);
          if (response.code === 200) {
            if (response.status === "SUCCESS") {
              console.log("rpc status success");
              onSuccess(response);
            } else {
              console.log("rpc status error");
              onErorr(response);
            }
          } else if (response.code === 401) {
            console.log("rpc 401");
//            this.showNtf(
//              "Important message",
//              "Please login to assess this page!",
//              "error"
//            );
            this.$router.push({ name: "login" });
          } else if (response.code === 403) {
            this.$router.push({ name: "login" });
            if (this.$cookies.isKey("user-token"))
              this.$cookies.remove("user-token");
          } else if (response.code === 404) {
            console.log("rpc 401");
          } else {
            console.log("rpc else");
            this.showNtf("Important message", "Something went wrong!", "error");
          }
        },
        error => {
          console.log("rpc error --- " + method, error);
          if (error.response.status === 401) {
//            this.showNtf(
//              "Important message",
//              "Please login to assess this page!",
//              "error"
//            );
            this.$router.push({ name: "login" });
            if (this.$cookies.isKey("user-token"))
              this.$cookies.remove("user-token");
          }
        }
      );
    },
    showNtf(title, text, type) {
      this.$notify({
        group: "user",
        title: title,
        text: text,
        type: type
      });
    }
  }
};
